<template>
  <div class="content-libros-detalle">
    <v-container id="libros" fluid class="global-paddings">
      <v-row>
        <v-col
          cols="12"
          md="6"
          v-if="book.link == $route.params.name"
          :class="bImgMobile ? 'z-index-2' : ''"
        >
          <div
            class="content-img-box"
            :style="cssContentImg()"
            v-show="bImgMobile"
          >
            <img class="img-box" :style="cssImg()" :src="book.image" />
          </div>

          <div id="fixed-content" class="fixed-content">
            <img v-show="!bImgMobile" :src="book.image" />
          </div>
        </v-col>
        <v-col
          :class="bImgMobile ? 'z-index-4' : ''"
          cols="12"
          md="6"
          v-if="book.link == $route.params.name"
        >
          <div>
            <div
              style="line-height: 40px; flex-flow: wrap"
              class="display-flex align-items-center content-title"
            >
              <p class="txt-title" v-html="book.title" />
            </div>
            <div
              class="wrap-txt display-flex align-items-center content-subtitle"
            >
              <p class="txt-subtitle">
                {{ book.subtitle }}
              </p>
            </div>
            <p class="txt-description" v-html="book.description" />
            <div v-if="book.sId === 1">
              <p class="txt-description-italics">Connect the dots!</p>
              <p class="txt-description">Dra. Nora A. Hinojosa-Ayala</p>
              <p class="txt-description-italics-author">
                Directora General del Instituto de Psicoterapia
              </p>
            </div>
          </div>
          <div class="separator" />
          <div v-if="book.sId === 2" class="content-button-amazon">
            <v-menu>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="button-amazon-first" v-bind="attrs" v-on="on">
                  Comprar en
                </v-btn>
              </template>
              <v-list>
                <v-list-item class="list-buttons">
                  <v-row>
                    <v-col
                      v-for="(item, index) in book.aLinks"
                      :key="index"
                      xs="12"
                      sm="6"
                      md="6"
                      lg="6"
                      xl="6"
                    >
                      <v-btn
                        class="button-amazon"
                        :href="item.link"
                        target="blank"
                      >
                        <img width="85px" :src="item.background" />
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <div v-else>
            <v-btn
              v-if="book.sId === 1"
              class="button-amazon mt-2"
              href="https://www.amazon.com.mx/El-punto-animado-Spanish-Mai/dp/B09WWFNJWN"
              target="blank"
            >
              Comprar en
              <img
                class="ml-2"
                width="85px"
                src="@/assets/images/amazonMX.png"
              />
            </v-btn>
            <v-btn
              v-if="book.sId === 1"
              class="button-amazon mt-2"
              href="https://www.amazon.com/El-punto-animado-Spanish-Mai-ebook/dp/B09WZ76VQ2/ref=tmm_kin_swatch_0?_encoding=UTF8&qid=1679600694&sr=8-1"
              target="blank"
            >
              Comprar en
              <img
                class="ml-2"
                width="85px"
                src="@/assets/images/amazonEULogo.png"
              />
            </v-btn>

            <v-btn
              v-if="book.sId === 3"
              class="button-amazon mt-2"
              href="https://www.amazon.com.mx/Pol%C3%ADticamente-incorrecta-Mar%C3%ADa-Fernanda-Garc%C3%ADa-ebook/dp/B09T8KM27Y/ref=sr_1_2?__mk_es_MX=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=3MQNH6FEMNRSN&keywords=politicamente+incorrecta&qid=1646075814&sprefix=politicamente+incorrect%2Caps%2C193&sr=8-2"
              target="blank"
            >
              Comprar en
              <img class="ml-2" width="85px" src="@/assets/images/amazon.svg" />
            </v-btn>

            <v-btn
              v-if="book.sId === 3"
              class="button-amazon mt-2"
              href="https://frankfurtrights.com/Books/Details/pol-ticamente-incorrecta-segundo-s emestre-19049915"
              target="blank"
            >
              Comprar en
              <img
                class="ml-2"
                width="85px"
                src="@/assets/images/Logo-Frankfurt-Rights.png"
              />
            </v-btn>
            <v-btn
              v-if="book.sId === 3"
              class="button-amazon mt-2"
              href="https://www.amazon.com.mx/Pol%C3%ADticamente-incorrecta-Segundo-semestre-Spanish/dp/B09T87JR8W/ref=sr_1_3?adgrpid=56953698719&hvadid=590607960916&hvdev=c&hvlocphy=9073927&hvnetw=g&hvqmt=b&hvrand=1881859843089781302&hvtargid=kwd-440682670524&hydadcr=27009_14537432&keywords=politicamente+incorrectas&qid=1679531912&sr=8-3"
              target="blank"
            >
              Comprar en
              <img
                class="ml-2"
                width="85px"
                src="@/assets/images/amazonMX.png"
              />
            </v-btn>
            <v-btn
              v-if="book.sId === 3"
              class="button-amazon mt-2"
              href="https://www.amazon.com/Pol%C3%ADticamente-incorrecta-Segundo-semestre-Spanish/dp/B09T87JR8W/ref=tmm_pap_swatch_0?_encoding=UTF8&qid=1679533477&sr=1-1"
              target="blank"
            >
              Comprar en
              <img
                class="ml-2"
                width="85px"
                src="@/assets/images/amazonEULogo.png"
              />
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- TESTIMONIOS -->
    <div
      :class="bImgMobile ? 'z-index-4' : ''"
      id="testimonios"
      class="content-testimonios"
    >
      <p class="txt-testimonios">Testimonios</p>
      <div style="position: relative" v-if="slider.length > 0">
        <carousel
          :dots="false"
          :nav="false"
          :draggable="false"
          :items="3"
          :responsive="responsiveCarousel"
          :loop="true"
        >
          <div
            v-for="(item, index) in slider"
            :key="index"
            class="content-card-carousel"
          >
            <p class="txt-comentario" v-html="item.comentario" />
            <p class="txt-persona" v-html="item.persona" />
            <p class="txt-puesto" v-html="item.puesto" />
            <div class="image-testimonio">
              <img :src="imagen" />
            </div>
          </div>
          <!-- hidde buttons -->
          <template slot="prev">
            <span ref="buttonPrev"></span>
          </template>
          <template slot="next">
            <span ref="buttonNext"></span>
          </template>
        </carousel>
        <!-- show buttons -->
        <div class="buttons-carousel">
          <v-btn
            icon
            rounded
            elevation="0"
            class="carousel-button-left"
            :ripple="false"
            @click="$refs.buttonPrev.click()"
          >
            <v-icon size="80px" color="#A3332C"> mdi-chevron-left </v-icon>
          </v-btn>
          <v-btn
            icon
            rounded
            elevation="0"
            class="carousel-button-right ml-2"
            :ripple="false"
            @click="$refs.buttonNext.click()"
          >
            <v-icon size="80px" color="#A3332C"> mdi-chevron-right </v-icon>
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";

export default {
  name: "LibrosDetalle",
  data: () => ({
    bgColor: "blue",
    widthContentImg: 0,
    heightImg: 130,
    bgSize: 70,
    bgPosition: 10,
    bImgMobile: false,
    screenWidth: 0,
    slider: [],
    iBook: 0,
    sliderss: [
      // {
      //   comentario: "Magnífica obra que motiva a nuestros niños a ser creativos.",
      //   persona: "Dr. Héctor Arriaga Flores",
      //   puesto: "Pediatra",
      //   image: require("@/assets/images/icons/feliz-derecha.svg"),
      // },
      // {
      //   comentario:
      //     "Excelente cuento que proporciona en el niño el desarrollo creativo de metas, motiva el trabajo en equipo y el amor a la sociedad, en especial a nuestro querido México.",
      //   persona: "Dra. María del Carmen Ayala de la Cruz",
      //   puesto: "Inmunoalergóloga pediatra",
      //   image: require("@/assets/images/icons/sonriendo-loco.svg"),
      // },
      // {
      //   comentario:
      //     "Este es un cuento muy puntual. Conectar los puntos, esa es la clave. Unir la sabiduría con el candor, la profundidad con la sencillez, el miedo a equivocarse con la pasión por hacer y aprender, el humor con la filosofía y hacerlo todo con un gran amor y sentido estético. En este cuento cabemos todos, como cabemos en un universo en que somos puntos diminutos que, sin embargo, cuando se unen adquieren la capacidad maravillosa de cambiarlo todo, empezando por nosotros mismos.",
      //   persona: "Fernando Elizondo Barragán",
      //   puesto: "Exgobernador, senador y secretario de energía de Nuevo León",
      //   image: require("@/assets/images/icons/bigotes.svg"),
      // },
      // {
      //   comentario:
      //     "El punto animado: chispa creativa, producto de un gran talento. Si a nuestros seres queridos desde el principio de su existencia logramos transmitirles el significado de El punto animado, habremos plantado la semilla de una vida plena de realizaciones, porque contado de una manera muy sencilla, tiende a eliminar el miedo, que paraliza e inhibe.",
      //   persona: "Eduardo García Alanís",
      //   puesto: "Empresario",
      //   image: require("@/assets/images/icons/feliz-izquierda.svg"),
      // },
      // {
      //   comentario:
      //     "El cuento es muy original. Contiene mensajes con surrealismos simples, sencillos pero profundos, aprovechando la nueva sociedad de la comunicación rápida y corta. A veces una imágen con mensaje vale más que las palabras.",
      //   persona: "Elvira Lozano de Todd",
      //   puesto: "Directora de la pinacoteca de Nuevo León",
      //   image: require("@/assets/images/icons/sonriendo.svg"),
      // },
      // {
      //   comentario:
      //     "¡Que alguien haga algo! es la premisa sobre la que se desarrolla este cuento, para hacernos reflexionar acerca de la pasividad de la sociedad en la que vivimos. Es muy acertada la apuesta de la autoría a la capacidad que tienen sus jóvenes lectores para la adquisición del lenguaje y para el aprendizaje.",
      //   persona: "Dra. Blanca López de Mariscal",
      //   puesto:
      //     "Dir. del programa de maestría y doctorado en Estudios Humanísticos de ITESM, campus Monterrey <br/> Autora de The harvest birds (Los pájaros de la cosecha). <br/> Chidlren´s Book Press, CA.",
      //   image: require("@/assets/images/icons/gatita.svg"),
      // },
      // {
      //   comentario:
      //     "Quiero felicitar a María Fernanda por este bello libro, sus dibujos frescos y palabras profundas con un hermoso mensaje fácil de entender. <br/> Todos podemos lograr nuestros sueños sí nos lo proponemos. Hay una frase que me encanta que dice así: “¿Cuál es la diferencia entre un sueño y una meta? ¡la fecha!”. Si a nuestros sueños le ponemos fecha los hacemos realidad.",
      //   persona: "Liliana Melo de Sada",
      //   puesto:
      //     "Presidenta de la Escuela Superior de Música y Danza de Monterrey. <br /> Presidenta del Festival Internacional de Santa Lucía en Nuevo León. <br/> Consejera de diferentes instituciones culturales en el país y en el extranjero.",
      //   image: require("@/assets/images/icons/feliz-derecha.svg"),
      // },
      // {
      //   comentario:
      //     "De manera sencilla, este cuento nos presenta los valores más relevante que los mexicanos deberíamos vivir; entendiendo por valores, aquellas fuerzas que deben gobernar nuestro comportamiento, tales como: la pasión por enfrentar los retos (emprendimiento); valorar la colaboración de los demás (trabajo en equipo); el coraje para vencer las adversidades de la vida (tenacidad); sentirnos responsables de los demás (solidaridad) y el coraje y la pasión ante la vida (actitud positiva). Nuestra sociedad sería otra, y nosotros mismos, si estos valores fueran nuestro credo de vida.",
      //   persona: "David Noel Ramírez Padilla",
      //   puesto: "Rector del Instituo Tecnológico y de Estudios Superiores de Monterrey",
      //   image: require("@/assets/images/icons/sonriendo-loco.svg"),
      // },
      // {
      //   comentario:
      //     "Sencillez, creatividad, imaginación, humor sutil, que de forma amena nos enseña a liberarnos de las barreras que nos impiden amarnos, valorarnos y vencer los miedos para lograr dar y recibir.",
      //   persona: "Mónica Sada de Iriondo",
      //   puesto: "Fundadora del Instituto San Roberto",
      //   image: require("@/assets/images/icons/sonriendo.svg"),
      // },
      // {
      //   comentario:
      //     "¡Felicidades, María Fernanda! Qué bonito mensaje deja el cuento, y de una manera u otra hay que poner siempre nuestro granito de arena en beneficio de la sociedad. Tenemos que crear conciencia que la lectura es una herramienta básica para la educación, para que las nuevas generaciones tengan oportunidades y sean personas de bien.",
      //   persona: "Federico Santos Boesch",
      //   puesto: "Vicepresidente La Gran Familia <br/> Presidente de Andares ABP",
      //   image: require("@/assets/images/icons/feliz-derecha.svg"),
      // },
      // {
      //   comentario:
      //     "It warmed my heart! <3 <br/> En tiempos como estos, cuentos con valores tan importantes son esenciales. La situación y sentimientos por los que atraviesa el personaje principal, nos ha pasado a todos sin importar el nivel socioeconómico o cultural. La edad del lector es indistinta cuando se trata de aprender, ya que estos valores son universales; simplemente te identificas por humanidad. María Fernanda me ha envuelto por momentos en una motivación y luz acogedora. Me quedé feliz y será algo que compartiré con toda la gente que amo.",
      //   persona: "Daniela Serna",
      //   puesto: "DJ <br/> Directora General de Minisoundlight",
      //   image: require("@/assets/images/icons/gatita.svg"),
      // },
      // {
      //   comentario:
      //     "La sencillez de El punto animado no nos debe distraer de su gran sprofundidad que lo emparenta con los koans de la tradición japonesa zen, donde la comprensión de la plena significación de una simple sílaba como mu nos lleva a la iluminación, señalada por Buda como el gran objetivo de la vida humana. Con este sabio punto la autora ahonda en las grandes lecciones de vida que muchas veces sólo un niño puede comprender. Enhorabuena por esta nueva pluma regiomontana que nos recuerda la genial simplicidad de Saint-Exupéry.",
      //   persona: "Cristina Sada Salinas",
      //   puesto: "Fundadora del Instituto San Roberto",
      //   image: require("@/assets/images/icons/feliz-izquierda.svg"),
      // },
      // {
      //   comentario:
      //     "¡Felicidades, María Fernanda! Qué bonito mensaje deja el cuento, y de una manera u otra hay que poner siempre nuestro granito de arena en beneficio de la sociedad. Tenemos que crear conciencia que la lectura es una herramienta básica para la educación, para que las nuevas generaciones tengan oportunidades y sean personas de bien.",
      //   persona: "Federico Santos Boesch",
      //   puesto: "Vicepresidente La Gran Familia <br/> Presidente de Andares ABP",
      //   image: require("@/assets/images/icons/feliz-derecha.svg"),
      // },
      // {
      //   comentario:
      //     "It warmed my heart! <3 <br/> En tiempos como estos, cuentos con valores tan importantes son esenciales. La situación y sentimientos por los que atraviesa el personaje principal, nos ha pasado a todos sin importar el nivel socioeconómico o cultural. La edad del lector es indistinta cuando se trata de aprender, ya que estos valores son universales; simplemente te identificas por humanidad. María Fernanda me ha envuelto por momentos en una motivación y luz acogedora. Me quedé feliz y será algo que compartiré con toda la gente que amo.",
      //   persona: "Daniela Serna",
      //   puesto: "DJ <br/> Directora General de Minisoundlight",
      //   image: require("@/assets/images/icons/gatita.svg"),
      // },
      // {
      //   comentario:
      //     "La sencillez de El punto animado no nos debe distraer de su gran sprofundidad que lo emparenta con los koans de la tradición japonesa zen, donde la comprensión de la plena significación de una simple sílaba como mu nos lleva a la iluminación, señalada por Buda como el gran objetivo de la vida humana. Con este sabio punto la autora ahonda en las grandes lecciones de vida que muchas veces sólo un niño puede comprender. Enhorabuena por esta nueva pluma regiomontana que nos recuerda la genial simplicidad de Saint-Exupéry.",
      //   persona: "Cristina Sada Salinas",
      //   puesto: "Fundadora del Instituto San Roberto",
      //   image: require("@/assets/images/icons/feliz-izquierda.svg"),
      // },
    ],
    responsiveCarousel: {
      0: { items: 1, nav: false },
      425: { items: 1, nav: false },
      600: { items: 2, nav: false },
      960: { items: 2, nav: false },
      1264: { items: 3, nav: false },
      1636: { items: 4, nav: false },
      1904: { items: 4, nav: false },
    },
    items: [
      {
        sId: 1,
        backgroundImage: `url(${require("@/assets/images/libro1.png")})`,
        image: require("@/assets/images/libro1.png"),
        link: "el-punto-animado",
        title: "el punto animado",
        subtitle: "LITERATURA INFANTIL",
        description:
          "Es increible que una palabra con connotaciones diminuias pueda tener tan diversos y ricos significados, asi como la fuerza para inspirar un cuento. <br/> <br/> “Pinto del <span class='font-style-italica'>latin punctum</span>, puede ser una señal pequeña en forma de circulo, puede ser un lugar o sitio de concurrencia, indicar un instante o un momento, determinar un valor. ser la parte importante de un asunto, el fin de una acción o de una frase.1<br/> <span class='font-style-italica' >El punto es tiempo</span>, espacio y materia articulados, es un respiro, una pausa. En su cuento El punto animado, María Fernanda le ha dotado al mismo de alma y de movimiento, obteniendo un resultado divertido, vivo. Tal vez un soplo en términos espirituales.<br/> El “punto” del cuento, es la soledad sin posibilidad de acción y el encuentro con el otro como cura y catalizador de crecimiento. La espera va <span class='font-style-italica'>in crescendo</span> y nos conduce a la tensión que conlleva experimentar la inmovilidad. El discurso que se devela en <span>El punto animado</span> es propio de los estados traumáticos, en donde el tiempo se percibe suspendido y el cuerpo experimenta un estado de congelamiento. María Fernanda transmite de una manera natural y estética la soledad infantil, que cuando es profunda, imposibilita el paso de eventos subsecuentes.<br/> Los elementos que entran en la conversación son totalmente sorpresivos. Otros “puntos acompañan al personaje principal. El tiempo es presentado como gran aliado ya que en forma de estaciones, propicia cambios.<br/> Aparece una voz, la Hoja Blanca como una figura femenina simbolizando una madre/abuela, que alientan como soplo hacia la transformación. Esta <span style='font-style: italic;'>ánima</span> nos recuerda al Génesis: “En un principio fue el verbo”. <br/> Los dibujos son una delicia ya que en su sencillez está su estética y capacidad de conectividad con el mundo infantil al cual está dirigido. El personaje de Punto hace honor a su nombre realizando una pausa para respirar y explorar sus dudas. La duda cartesiana asalta a nuestro pequeño Punto: no tenemos posibilidad de conocer la verdad. No hay caminos seguros o ciertos, sólo nuestros propios caminos. Según R. Descartes se puede dudar de todo menos de que (ego) existimos: <span style='font-style: italic;'>cogito ergo sum</span>. <br/> Lo maravilloso del cuento de María Fernanda es que va más allá. Existimos a través de la conjunción puntual de nuestras ideas, nuestros sentimientos y la belleza de la fantasía. El comienzo de un cambio es experimentar la necesidad del mismo. <br/> El mundo interior de las emociones con frecuencia es un mundo fantasmal y sólo siendo agente se le domina. La apropiación del “sí mismo” es a través de palabras y acciones intencionales, siendo ello un signo de cambio psíquico, el <span style='font-style: italic;'>self as agency</span>. <br/> Esta enseñanza es la que María Fernanda trasmite con tanta dulzura y sencillez. <br/> Hacer pausas para pensar nuestras dudas, el manejo del tiempo, la acción, aceptación y crecimiento interior inspiran al pequeño a que escuche este cuento va que únicamente a través de las historias podemos asomarnos a los abismos de lo humano y descubrir la esperanza del valor de la vida.",
        linkAmazon:
          "https://www.amazon.com.mx/El-punto-animado-Spanish-Mai/dp/B09WWFNJWN",
      },
      {
        sId: 2,
        backgroundImage: `url(${require("@/assets/images/libro2.png")})`,
        image: require("@/assets/images/libro2.png"),
        link: "politicamente-incorrecta-primer-semestre",
        title: "Políticamente incorrecta",
        subtitle: "PRIMER SEMESTRE",
        // description:
        //   `Tras meterse en problemas con la autoridad en París durante las vacaciones de verano en la Copa del Mundo 1998, las dificultades envuelven a Isabela, una escandalosa <span style='font-style: italic;'>socialité mexicana</span>, mayor de edad, proveniente de una familia conservadora de San Pedro Garza García. Ante el “qué dirán” dentro del círculo provinciano, sus padres deciden mandarla a estudiar a Suiza al colegio de protocolo y etiqueta más prestigioso y exclusivo del mundo: el Institut Léman. El objetivo: refinar sus modales y convertirla en una dama de primer nivel como “las de hierro”. A través de los entrañables vínculos que forma con el personal del colegio y las amistades multiculturales, Isabela aprenderá a resolver con ingenio, decisión y mucho orgullo mexicano cada una de sus aventuras cargadas de lecciones de madurez que la marcarán de por vida. Este es el primer tomo de la serie <span style='font-style: italic;'>Políticamente incorrecta</span>, una novela escrita con picardía, humor ligero y mucha diversión sin dejar de lado la importancia de los valores, el aprendizaje y la condición humana.`,
        description: `   
              <p class="text-center font-weight-black mb-3">Una carcajada puede ser infinita hasta que la vida te da una patada en el <span class='font-italic'>derrière</span>.</p>
              
              <p class="text-center font-weight-black mb-0"> * <p/>
              
              <p class="txt-letter-space-0">
              Tras meterse en problemas con la autoridad en París durante las vacaciones de verano en la Copa
              del Mundo 1998 las dificultades envuelven a Isabela, una escandalosa  <span class='font-italic'> socialité</span> mexicana, mayor
              de edad, proveniente de una familia conservadora de San Pedro Garza García. Ante el “qué
              dirán” dentro del círculo provinciano, sus padres deciden mandarla a estudiar a Suiza al colegio
              de protocolo y etiqueta más prestigioso y exclusivo del mundo: el Institut Léman. El objetivo:
              refinar sus modales y convertirla en una dama de primer nivel como “las de hierro”. <br/>
              A través de los lazos que forma con el personal del colegio y las amistades
              multiculturales, Isabela aprenderá a resolver con ingenio, decisión y mucho orgullo mexicano los
              líos cargados de lecciones que la marcarán de por vida.
              <p/>

              <p class="text-center font-weight-black mb-0"> * <p/>

              <p class="pl-6 pr-6 txt-letter-space-1">
                Fue un largo debate cultural y religioso camino hacia el instituto. Me
                preguntaba si me castigarían. Ya me imaginaba a Petit diciendo:<span class='font-italic'> “Mon Dieu,</span> ¡qué
                pesadilla!” y yo agregando en mi defensa: “Ajá, ¡qué pesadilla estar sin hombres!” y
                moviendo el vientre—: “¡Mire, <span class='font-italic'> madame</span>, como me enseñó Imán a mover el
                <span class='font-italic'>derrière!”</span>.                
              </'p'>

              <p class="text-center font-weight-black mb-0"> * <p/>

              <p class="text-center">No te pierdas del siguiente tomo: <span class='font-italic text-center font-weight-black'> Políticamente incorrecta Segundo semestre</span>.</p>

              `,
        aLinks: [
          {
            background: require("@/assets/images/amazonEULogo.png"),
            link: "https://www.amazon.com/Pol%C3%ADticamente-incorrecta-Primer-semestre-Spanish/dp/B09T893TM9/ref=tmm_pap_swatch_0?_encoding=UTF8&qid=&sr=",
          },
          {
            background: require("@/assets/images/amazonMX.png"),
            link: "https://www.amazon.com.mx/Pol%C3%ADticamente-incorrecta-Primer-semestre-1/dp/B09T893TM9/ref=sr_1_1?adgrpid=56953698719&hvadid=590607960916&hvdev=c&hvlocphy=9073927&hvnetw=g&hvqmt=b&hvrand=1881859843089781302&hvtargid=kwd-440682670524&hydadcr=27009_14537432&keywords=politicamente+incorrectas&qid=1679531912&sr=8-1",
          },
          {
            background: require("@/assets/images/amazon.svg"),
            link: "https://www.amazon.com.mx/Pol%C3%ADticamente-incorrecta-Mar%C3%ADa-Fernanda-Garc%C3%ADa-ebook/dp/B09T86RT33/ref=sr_1_1?__mk_es_MX=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=3MQNH6FEMNRSN&keywords=politicamente+incorrecta&qid=1646075814&sprefix=politicamente+incorrect%2Caps%2C193&sr=8-1",
          },
          {
            background: require("@/assets/images/barnes-and-noble.png"),
            link: "https://www.barnesandnoble.com/w/pol-ticamente-incorrecta-mar-a-fernanda-garc-a-sada/1141289760?ean=9798422051113",
          },
          // {
          //   background: require("@/assets/images/bokklubben.png"),
          //   link:
          //     "https://www.bokklubben.no/humoristisk-skjoennlitteratur/politicamente-incorrecta-maria-fernanda-garcia-sada/produkt.do?produktId=58543000",
          // },
          {
            background: require("@/assets/images/dymocks.png"),
            link: "https://www.dymocks.com.au/book/pol%C3%ADticamente-incorrecta-by-mar%C3%ADa-fernanda-garc%C3%ADa-sada-9798422051113",
          },
          {
            background: require("@/assets/images/abebooks.png"),
            link: "https://www.abebooks.com/servlet/BookDetailsPL?bi=31147825770&search url=ds%3D20%26spo%3D20%26sortby%3D17%26kn%3DPol%25EDticam ente%2Bincorrecta%26p%3D2%26sp%3D1&cm_sp=snippet-_-srp2-_-imag e10",
          },
          {
            background: require("@/assets/images/bookshop.png"),
            link: "https://bookshop.org/p/books/politicamente-incorrecta-primer-semestre-maria-fernanda-garcia-sada/18356647?ean=9798422051113",
          },
          {
            background: require("@/assets/images/Logo-Frankfurt-Rights.png"),
            link: "https://frankfurtrights.com/Books/Details/pol-ticamente-incorrecta-primer-semestre-19049914",
          },
          {
            background: require("@/assets/images/elSotano.png"),
            link: "https://www.elsotano.com/libro/politicamente-incorrecta-primer-semestre_10638172",
          },
        ],
      },
      {
        sId: 3,
        backgroundImage: `url(${require("@/assets/images/libro3.png")})`,
        image: require("@/assets/images/libro3.png"),
        link: "politicamente-incorrecta-segundo-semestre",
        title: "Políticamente incorrecta",
        subtitle: "SEGUNDO SEMESTRE",
        // description:
        //   "Después de unas breves vacaciones navideñas en México, Isabela vuelve a Suiza para reanudar estudios en el Institut Léman, colegio de protocolo y etiqueta por excelencia. Los retos, las adversidades y los problemas se multiplican, crecen y se acentúan para la protagonista. A pesar de ello, sus objetivos no cambian: desea refinar modales y convertirse en una dama. Esto se vuelve una obsesión. Madurar no es un proceso fácil ni rápido, especialmente al convivir entre amistades de diversas costumbres, religiones e idiosincrasias. Sumado a ello, la joven conoce muchachos de su edad, entre los cuales descubre a Mâlik. En su perspectiva, todo parece un cuento de hadas. Sin embargo, una cadena de eventos desafortunados y situaciones de riesgo a las que se expone provocan que Isabela encuentre su dama de hierro interior y muestre lo mejor de sí. Sin dejar el humor característico de la protagonista, la autora nos guía por paisajes multiculturales aderezados por la natural problemática juvenil, donde el decidido orgullo mexicano resuelve cada una de las aventuras cargadas de lecciones de madurez. El segundo tomo de la serie <span style='font-style: italic;'>Políticamente incorrecta</span>, una novela escrita con picardía y mucha diversión, subraya la importancia de los valores, el aprendizaje y la condición humana.",
        description:
          `
          <p class="text-center font-weight-black mb-3">Una carcajada puede ser infinita hasta que te descubres esquizoide.</p>
          
          <p class="text-center font-weight-black mb-0"> * <p/>

          <p class="txt-letter-space-0">
            Después de unas breves vacaciones en México, Isabela vuelve a Suiza para reanudar estudios en
            el Institut Léman, colegio de protocolo y etiqueta. Todo parece un cuento de hadas,
            especialmente cuando se enamora de Mâlik, un  <span class='font-italic'> dandy </span> encantador, galán de Amira alias la
            Banshee, enemiga pública no.1 de Bela. Los líos se reproducen como <span class='font-italic'> gremlins </span>. <br/>
            Madurar no es un proceso fácil ni rápido, especialmente al convivir entre amistades de
            diversas costumbres, religiones e idiosincrasias. Una cadena de infortunios y situaciones de
            riesgo a las que se expone provocan que Isabela busque obsesivamente su dama de hierro interior
            y muestre lo mejor de sí.   
          </p>

          <p class="text-center font-weight-black mb-0"> * <p/>


          <p class="pl-6 pr-6 txt-letter-space-0">
            Vi mi rostro a través de las líneas que había escrito. El poco maquillaje que me quedaba
            se terminó de correr. Me veía tan espantosa que comencé un monólogo: <br/>
            —Así no va a pasar nada de nada, ¡ponte chispa! —la <span class='font-italic'> demonia </span> dentro de mí habló: traía
            la travesura por dentro.<br/>
            Al darme cuenta de que Bela o mi parte oscura estaba acaparando a mi parte luminosa,
            me di una cachetadita:<br/>
            —¡Despierta! Pero ¿¡en qué cosas estás pensando!? —la angelita Isabela dentro de mí
            reaccionó—. ¡Cállate, Bela, no estés mal influenciándome y no te vuelvas a aparecer el día de
            hoy, no eres bienvenida… qué ansia!             
          </'p'>

          <p class="text-center font-weight-black mb-0"> * <p/>

          <p class="text-center">No te pierdas del siguiente tomo: <span class='font-italic text-center font-weight-black'> Políticamente incorrecta Años universitarios.</span>.</p>


          `,
        linkAmazon:
          "https://www.amazon.com.mx/Pol%C3%ADticamente-incorrecta-Mar%C3%ADa-Fernanda-Garc%C3%ADa-ebook/dp/B09T8KM27Y/ref=sr_1_2?__mk_es_MX=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=3MQNH6FEMNRSN&keywords=politicamente+incorrecta&qid=1646075814&sprefix=politicamente+incorrect%2Caps%2C193&sr=8-2",
        linkFrankfurtRights:
          "https://frankfurtrights.com/Books/Details/pol-ticamente-incorrecta-segundo-s emestre-19049915",
      },
    ],
    aLinksBooks: [],
    oBook: {},
    imagen: "",
  }),
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    window.addEventListener("scroll", this.fixed);
    this.fixed();
  },
  beforeMount() {
    this.getBook();
    this.getReseñas();
  },
  destroyed() {
    window.removeEventListener("scroll", this.fixed);
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    fixed: function () {
      this.$nextTick(() => {
        if (this.$route.path == "/libros/el-punto-animado") {
          let fixed_div = document.getElementById("fixed-content");
          let libros =
            document.getElementById("libros").offsetTop -
            (window.scrollY + 100);
          let testimonios =
            document.getElementById("testimonios").offsetTop - 700;
          if (window.innerWidth > 960) {
            if (libros > -testimonios) {
              fixed_div.style.transform = `translateY(${-libros}px)`;
            }
          }
        }
      });
    },
    handleResize() {
      if (window.innerWidth > 959.99) {
        this.$nextTick(() => {
          if (this.$route.path == "/libros/el-punto-animado") {
            let fixed_div = document.getElementById("fixed-content");
            if (window.innerWidth < 960) {
              fixed_div.style.transform = "none";
            } else {
              this.fixed();
            }
          }
        });
        this.bImgMobile = false;
      } else {
        this.widthContentImg = window.innerWidth - 55;
        this.bImgMobile = true;
        if (window.innerWidth < 639.99) {
          this.bgSize = 45;
          this.heightImg = 1;
          this.bgPosition = 15;
        } else {
          this.bgSize = 70;
          this.heightImg = 130;
        }
      }
    },
    cssContentImg() {
      return {
        width: this.widthContentImg + "px",
      };
    },
    cssImg() {
      return {
        "background-size": this.bgSize + "vh",
        "min-height": this.heightImg + "px",
        "background-position": "50% " + this.bgPosition + "%",
      };
    },
    getReseñas() {
      if (this.$route.params.name === "el-punto-animado") {
        this.iBook = 1;
        this.imagen = require("@/assets/images/icons/feliz-izquierda.svg");
      } else if (
        this.$route.params.name === "politicamente-incorrecta-primer-semestre"
      ) {
        this.iBook = 2;
        this.imagen = require("@/assets/images/libros/Libro2.png");
      } else if (
        this.$route.params.name === "politicamente-incorrecta-segundo-semestre"
      ) {
        this.iBook = 3;
        this.imagen = require("@/assets/images/libros/Libro1.png");
      }
      let params = {
        iBook: this.iBook,
      };
      DB.get(`${URI}/messages`, {
        params,
        headers: {
          Authorization: "Bearer " + this.$store.state.sToken,
        },
      })
        .then((response) => {
          this.slider = response.data.messages.map((e) => {
            return {
              comentario: e.sMessage,
              persona: e.sName,
              puesto: e.sJobDescription,
            };
          });
          this.$store.commit("refresher", false);
        })
        .catch((error) => {
          this.Error(error.response.data.message);
        });
    },
    getBook() {
      let slink = this.$route.params.name;
      this.book = this.items.find((x) => x.link === slink);
    },
  },
  components: { carousel },
};
</script>

<style>
.list-buttons {
  display: flex;
  width: 100%;
  overflow: hidden;
}

.content-testimonios .owl-carousel .owl-stage {
  padding-top: 20px !important;
}

.content-testimonios .owl-item {
  height: 0;
}

.content-testimonios .owl-item.active {
  height: auto;
}

.parallax {
  position: relative;
  background-color: black;
  background-attachment: fixed;
  background-repeat: no-repeat;
  height: 100%;
}

.content-img-box {
  position: fixed;
  /* background-color: blue; */
  display: flex;
  place-content: center;
  width: 100%;
  height: 50%;
  max-height: 50%;
  min-height: 50%;
  z-index: 4px;
}

.img-box {
  object-fit: cover;
  position: absolute;
  height: 90%;
  max-height: 90%;
  min-height: 90%;
}

.z-index-4 {
  z-index: 4;
  background-color: white;
  position: relative;
}

.z-index-2 {
  z-index: 2;
}
</style>

<style scoped>
.fixed-content {
  width: 100%;
  height: 500px;
}

.fixed-content img {
  width: 100%;
  height: auto;
}

@supports (object-fit: contain) {
  .fixed-content img {
    height: 100%;
    object-fit: contain;
    object-position: center center;
  }
}

.image-testimonio {
  position: absolute !important;
  top: -5px;
  left: 50%;
  margin: -25px 0 0 -25px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #e2e2e2;
  border-radius: 100%;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px !important;
  max-height: 50px !important;
  min-height: 50px !important;
  width: 50px !important;
  max-width: 50px !important;
  min-width: 50px !important;
}

.image-testimonio img {
  width: 35px !important;
  height: 35px !important;
}

.buttons-carousel {
  position: absolute;
  z-index: 1;
  bottom: 320px;
  width: 100%;
  height: 100%;
  top: 0;
}

.carousel-button-left {
  width: 200px;
  position: absolute;
  left: 0;
  background: transparent linear-gradient(270deg, #fafafa00 0%, #fafafa 100%) 0%
    0% no-repeat padding-box;
  padding-left: 100px;
  height: 100%;
  border-radius: 0px;
}

.carousel-button-right {
  width: 200px;
  position: absolute;
  right: 0;
  background: transparent linear-gradient(270deg, #fafafa 0%, #fafafa00 100%) 0%
    0% no-repeat padding-box;
  padding-right: 100px;
  height: 100%;
  border-radius: 0px;
}

.carousel-button-right::before,
.carousel-button-left::before {
  background: transparent !important;
}

.content-card-carousel {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 4px;
  opacity: 1;
  margin: 10px;
  padding: 20px;
  position: relative;
}

.txt-comentario {
  text-align: left;
  font-size: 18px;
  letter-spacing: 0.14px;
  color: #000000;
  text-align: justify;
  text-justify: inter-word;
}

.txt-persona,
.txt-puesto {
  text-align: left;
  font-size: 14px;
  letter-spacing: 0.11px;
  color: #737373;
  text-align: left;
}

.slide-row {
  flex-wrap: inherit;
  overflow-x: auto;
}

.txt-testimonios {
  text-align: left;
  font-size: 70px;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  text-align: center;
}

.content-testimonios {
  background-color: #fafafa;
  padding-top: 50px;
  padding-bottom: 50px;
  position: relative;
}

.content-button-amazon {
  /* margin-bottom: 100px; */
  margin-bottom: 30px;
}

.button-amazon-first {
  background: #a3332c 0% 0% no-repeat padding-box !important;
  border-radius: 4px;
  font-size: 18px;
  width: 100%;
  text-transform: initial;
  color: #fff;
  height: 40px !important;
}

.button-amazon {
  background: #a3332c 0% 0% no-repeat padding-box !important;
  border-radius: 4px;
  font-size: 18px;
  width: 100%;
  text-transform: initial;
  color: #fff;
  height: 40px !important;
}

.list-buttons {
  display: flex;
}

.separator {
  border: 1px solid #e2e2e2;
  margin-top: 30px;
  margin-bottom: 30px;
}

.content-libros-detalle {
  margin-top: 96px;
}

.txt-title {
  text-align: left;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  font-size: 45px;
  text-transform: uppercase;
  margin-right: 10px;
}

.txt-title::first-letter {
  font-size: 50px;
}

.txt-subtitle {
  text-align: left;
  letter-spacing: 11px;
  color: #000000;
  opacity: 1;
  font-size: 18px;
  margin-right: 10px;
}

.txt-subtitle::first-letter {
  font-size: 23px;
}

.txt-description {
  /* text-align: left; */
  letter-spacing: 0.16px;
  line-height: 2;
  color: #212121;
  /* background-color: blue; */

  opacity: 1;
  font-size: 16px;
  text-align: justify;
  text-justify: inter-word;
}

.txt-description-italics {
  text-align: left;
  letter-spacing: 0.16px;
  line-height: 2;
  color: #212121;
  /* background-color: blue; */

  opacity: 1;
  font-size: 16px;
  text-align: justify;
  text-justify: inter-word;
  font-style: italic;
}

.txt-description-italics-author {
  text-align: left;
  letter-spacing: 0.16px;
  line-height: 2;
  color: #212121;
  /* background-color: blue; */
  margin-top: -20px;
  opacity: 1;
  font-size: 16px;
  text-align: justify;
  text-justify: inter-word;
  font-style: italic;
}

@media (max-width: 600px) {
  .wrap-txt {
    flex-wrap: wrap;
  }
}

@media (max-width: 960px) {
  .content-title {
    place-content: center;
    justify-content: center;
  }

  .txt-title {
    text-align: left;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    font-size: 45px;
    text-transform: uppercase;
    margin-right: 10px;
    text-align: center;
  }

  .content-subtitle {
    place-content: center;
    justify-content: center;
  }

  .txt-subtitle {
    text-align: left;
    letter-spacing: 11px;
    color: #000000;
    opacity: 1;
    font-size: 18px;
    margin-right: 10px;
    text-align: center;
  }

  .fixed-content {
    width: 100%;
    height: 400px;
  }

  @supports (object-fit: contain) {
    .fixed-content img {
      height: 100%;
      object-fit: contain;
      object-position: center center;
    }
  }

  .carousel-button-left {
    padding-left: 20px !important;
    width: fit-content;
  }

  .carousel-button-right {
    padding-right: 20px !important;
    width: fit-content;
  }
}

@media (min-width: 961px) and (max-width: 1260px) {
  .carousel-button-left {
    padding-left: 20px !important;
    width: fit-content;
  }

  .carousel-button-right {
    padding-right: 20px !important;
    width: fit-content;
  }
  .list-buttons {
    display: flex;
    width: 100%;
    overflow: hidden;
    max-width: 600px;
  }
}
</style>
